/* Savannah and Three — theme behaviours */
(function(){
  'use strict';
  var cfg = window.S3 || {};
  var $ = function(s, c){ return (c||document).querySelector(s); };
  var $$ = function(s, c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents){
    var value = (cents/100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = cfg.moneyFormat || '${{amount}}';
    var amt = parts.join('.');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amt).replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
  }

  /* ---------- drawer / overlays ---------- */
  function openDrawer(){ var d=$('#cartDrawer'); if(d) d.classList.add('open'); var o=$('#cartOverlay'); if(o) o.classList.add('show'); document.body.style.overflow='hidden'; }
  function closeDrawer(){ var d=$('#cartDrawer'); if(d) d.classList.remove('open'); var o=$('#cartOverlay'); if(o) o.classList.remove('show'); document.body.style.overflow=''; }
  function openMenu(){ var m=$('#mnav'); if(m) m.classList.add('open'); var o=$('#menuOverlay'); if(o) o.classList.add('show'); document.body.style.overflow='hidden'; }
  function closeMenu(){ var m=$('#mnav'); if(m) m.classList.remove('open'); var o=$('#menuOverlay'); if(o) o.classList.remove('show'); document.body.style.overflow=''; }

  function updateCount(n){
    n = parseInt(n,10) || 0;
    $$('.cartdot').forEach(function(d){ d.textContent = n; if(n>0){ d.removeAttribute('hidden'); } else { d.setAttribute('hidden',''); } });
  }

  /* ---------- cart section rendering ----------
     NOTE: /cart?sections=... must NOT be sent with an
     "Accept: application/json" header — Shopify then replies with the
     cart object instead of the rendered sections, which is why the
     drawer and cart page used to never update. We now ask for the
     sections on the add/change request itself and fall back to a
     header-less GET.                                                  */
  var busy = false;

  function sectionList(){
    var list = ['cart-drawer'];
    if(document.getElementById('mainCart')) list.push('main-cart');
    return list.join(',');
  }

  function setBusy(v){
    busy = v;
    [$('#cartDrawer .cart-items'), $('#mainCart')].forEach(function(el){
      if(!el) return;
      el.style.opacity = v ? '0.5' : '';
      el.style.pointerEvents = v ? 'none' : '';
    });
  }

  function applySections(sections){
    if(!sections) return false;
    var applied = false;

    if(sections['cart-drawer']){
      var el = $('#cartDrawer');
      if(el){ el.innerHTML = sections['cart-drawer']; applied = true; }
    }

    if(sections['main-cart']){
      var mc = $('#mainCart');
      if(mc){
        var tmp = document.createElement('div');
        tmp.innerHTML = sections['main-cart'];
        var fresh = tmp.querySelector('#mainCart');
        if(fresh){ mc.innerHTML = fresh.innerHTML; applied = true; }
      }
    }

    if(applied){
      var c = $('#cartDrawer [data-cart-count]');
      updateCount(c ? c.getAttribute('data-cart-count') : 0);
    }
    return applied;
  }

  function refreshCart(open){
    return fetch('/cart?sections=' + sectionList(), {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(j){ applySections(j); if(open) openDrawer(); })
      .catch(function(){ if(open) openDrawer(); });
  }

  function addVariant(id, qty, btn){
    if(!id) return;
    if(btn){
      if(!btn.dataset.label) btn.dataset.label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }
    fetch('/cart/add.js', {
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: id, quantity: parseInt(qty,10) || 1, sections: sectionList() })
    })
      .then(function(r){ if(!r.ok) return r.json().then(function(e){ throw e; }); return r.json(); })
      .then(function(j){
        if(applySections(j.sections)){ openDrawer(); return; }
        return refreshCart(true);
      })
      .catch(function(e){ alert((e && e.description) || 'Sorry, this item could not be added.'); })
      .finally(function(){ if(btn){ btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; } });
  }

  function changeLine(key, qty){
    if(busy || !key) return;
    var q = parseInt(qty, 10);
    if(isNaN(q) || q < 0) return;
    setBusy(true);
    return fetch('/cart/change.js', {
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: key, quantity: q, sections: sectionList() })
    })
      .then(function(r){ return r.json(); })
      .then(function(j){ if(!applySections(j.sections)) return refreshCart(false); })
      .catch(function(){ return refreshCart(false); })
      .finally(function(){ setBusy(false); });
  }

  /* ---------- signup popup ---------- */
  function popupSeen(){ try { return localStorage.getItem('s3_popup') === '1'; } catch(e){ return false; } }
  function markPopup(){ try { localStorage.setItem('s3_popup','1'); } catch(e){} }
  function closePopup(){ var p=$('#signupPopup'); if(p) p.classList.remove('show'); var o=$('#popupOverlay'); if(o) o.classList.remove('show'); markPopup(); }
  function maybeOpenPopup(){
    var p = $('#signupPopup'); if(!p || popupSeen()) return;
    var d = $('#cartDrawer');
    if(d && d.classList.contains('open')){ setTimeout(maybeOpenPopup, 3000); return; }
    p.classList.add('show'); var o=$('#popupOverlay'); if(o) o.classList.add('show');
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function(e){
    if(!e.target || !e.target.closest) return;
    var t = e.target.closest('[data-action]');
    if(t){
      var a = t.getAttribute('data-action');
      if(a==='cart-open'){ e.preventDefault(); refreshCart(true); return; }
      if(a==='cart-close'){ closeDrawer(); return; }
      if(a==='menu-open'){ openMenu(); return; }
      if(a==='menu-close'){ closeMenu(); return; }
      if(a==='popup-close'){ closePopup(); return; }
      if(a==='quick-add'){ e.preventDefault(); e.stopPropagation(); addVariant(t.getAttribute('data-variant-id'), 1, t); return; }
      if(a==='line-change'){ e.preventDefault(); changeLine(t.getAttribute('data-key'), t.getAttribute('data-qty')); return; }
    }
  });

  /* ---------- typed quantity on the cart page ---------- */
  document.addEventListener('change', function(e){
    var i = e.target;
    if(!i || !i.matches || !i.matches('[data-line-qty]')) return;
    changeLine(i.getAttribute('data-key'), i.value);
  });

  /* ---------- PDP ---------- */
  function initProduct(){
    var form = $('#productForm'); if(!form) return;
    var variantInput = $('#variantId', form);
    var priceEl = $('#pdpPrice');
    var addBtn = $('#pdpAdd');
    var qtyInput = $('#pdpQty');

    $$('.size', form).forEach(function(b){
      b.addEventListener('click', function(){
        if(b.disabled) return;
        $$('.size', form).forEach(function(x){ x.classList.remove('on'); });
        b.classList.add('on');
        if(variantInput) variantInput.value = b.getAttribute('data-variant-id');
        var price = b.getAttribute('data-price');
        if(price && addBtn){ addBtn.innerHTML = 'Add to cart · ' + formatMoney(parseInt(price,10)); }
      });
    });

    if(qtyInput){
      var dec = $('#qtyDec'), inc = $('#qtyInc'), disp = $('#qtyDisp');
      function setQ(v){ v = Math.max(1, v); qtyInput.value = v; if(disp) disp.textContent = v; }
      if(dec) dec.addEventListener('click', function(){ setQ(parseInt(qtyInput.value,10)-1); });
      if(inc) inc.addEventListener('click', function(){ setQ(parseInt(qtyInput.value,10)+1); });
    }

    form.addEventListener('submit', function(e){
      e.preventDefault();
      var id = variantInput ? variantInput.value : null;
      if(!id){ alert('Please choose an option first.'); return; }
      addVariant(id, qtyInput ? parseInt(qtyInput.value,10) : 1, addBtn);
    });

    /* sticky bar */
    var sticky = $('#stickyAtc');
    if(sticky){
      window.addEventListener('scroll', function(){
        if(window.scrollY > 640) sticky.classList.add('show'); else sticky.classList.remove('show');
      }, {passive:true});
      var sBtn = $('#stickyAdd');
      if(sBtn) sBtn.addEventListener('click', function(){ addVariant(variantInput ? variantInput.value : null, 1, sBtn); });
    }

    /* gallery thumbs */
    $$('.thumb').forEach(function(th){
      th.addEventListener('click', function(){
        var src = th.getAttribute('data-full');
        var main = $('#galleryMain');
        if(src && main){ main.src = src; }
        $$('.thumb').forEach(function(x){ x.classList.remove('on'); });
        th.classList.add('on');
      });
    });
  }

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function(){
    document.documentElement.classList.remove('no-js');
    initProduct();
    updateCount(cfg.cartCount || 0);
    setTimeout(maybeOpenPopup, 4500);
  });
})();
